import { transformFeatures } from "../identity";

// Map from the API response for search customers to the select dropdown options
export const mapCustomersToOptions = (response) => {
  return response.map((x) => ({
    ...x,
    key: x.id,
    value: x.id,
    features: transformFeatures(x),
    phone: x.phoneNumber,
    email: x.emailAddress,
    siteGuid: x.site?.guid,
    text: `${x.forename ?? ""} ${x.surname ?? ""} ${x.phoneNumber && "(" + x.phoneNumber + ")"}`,
  }));
};

// Map from the dropdown options to the display table
export const castCustomerToTable = (customer) => {
  return {
    id: customer.id || customer.key,
    name: customer.name || customer.text,
    features: customer.features,
    phone: customer.phone ?? customer.phoneNumber,
    email: customer.email ?? customer.emailAddress,
  };
};

// Map from the selected customer to submission back to the API
export const castCustomerForSubmission = (customer) => {
  return {
    id: customer.key,
    name: customer.text,
    hasBeenModified: false,
    rowVersion: customer.rowVersion,
  };
};

// Filter outcomes options for customer interaction form select based on is customer is ok
export const filterOutcomes = (outcomes, value) =>
  outcomes
    .filter((x) => x.customerOk === value)
    .map((x) => {
      return { value: x.id, text: x.name };
    });
